export default "__VITE_ASSET__CLyHgc2f__"